import { IDmKhoiNganh } from "../../../model/response/category/IDmKhoiNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKhoiNganhActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDmKhoiNganh[],
    LOAD_ERROR: "",
};
export const eKhoiNganhActionIds = generateActionTypeIds(eKhoiNganhActionsObj, "KHOI_NGANH");
export type IKhoiNganhActionTypes = IGenericActionType<typeof eKhoiNganhActionsObj, "KHOI_NGANH">;
